import { render, staticRenderFns } from "./AddWebinar.vue?vue&type=template&id=7f130a78&scoped=true"
import script from "./AddWebinar.vue?vue&type=script&lang=js"
export * from "./AddWebinar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f130a78",
  null
  
)

export default component.exports